import Field from '@arcgis/core/layers/support/Field';

export class AssetFieldsService {
    public getMapFields(): Field[] {
        return this._fields.map((e) => new Field(e));
    }
    // NOTE: These fields must be kept consistent with changes to SpatialEntityDataExtended in order to pass data with map Graphics
    // TODO: these fields need to be renamed to be more general, less specific
    private _fields: any[] = [
        // Unique identifiers
        {
            name: 'ObjectID',
            alias: 'ObjectID',
            type: 'oid',
        },
        {
            name: 'entityId',
            alias: 'entityId',
            type: 'string',
        },
        {
            name: 'entityType',
            alias: 'entityType',
            type: 'string',
        },
        {
            name: 'tooltipType',
            alias: 'tooltipType',
            type: 'string',
        },
        // Data
        {
            name: 'colour',
            alias: 'colour',
            type: 'string',
        },
        {
            name: 'data',
            alias: 'data',
            type: 'string',
        },
        {
            name: 'count',
            alias: 'count',
            type: 'integer',
        },
        {
            name: 'renderedVisualizationType',
            alias: 'renderedVisualizationType',
            type: 'string',
        },
        {
            name: 'metric',
            alias: 'metric',
            type: 'string',
        },
    ];
}
